




































import Vue from 'vue';
import CustomerRemark from '../../models/CustomerRemark';
import customerVuex from '../../vuex/common';
import customerClient from '../../apis';
import commonClient from '../../../common/apis';
import RiskBox from '../../../common/components/ui/RiskBox/index.vue';
import { TaskType } from '../../../common/models/TaskType';

const remark: CustomerRemark | null = null;

export default Vue.extend({
  mixins: [customerVuex],
  props: {
    outerRemark: Object,
    mergeMode: Boolean,
  },
  components: {
    RiskBox,
  },
  data() {
    return {
      selected: false,
      editMode: false,
      showDeleteBox: false,
      remark,
    };
  },
  computed: {
    inMergingRemarks(): boolean {
      return this.customerState.mergingRemarks.some(
        (remark: CustomerRemark) => {
          return remark.id === this.remark!.id;
        },
      );
    },
  },
  methods: {
    toggleRemarkStatus() {
      if (this.mergeMode) {
        if (this.selected) {
          this.$store.commit('CANCEL_MERGING_REMARK_ITEM', this.remark!.id);
        } else {
          this.$store.commit('SELECT_MERGING_REMARK_ITEM', this.remark);
        }
      }
    },
    confirmRemarkName() {
      if (this.remark && this.remark.remarkName && this.remark.remarkName.trim() !== '') {
        customerClient.renameRemark({
          id: this.remark.id,
          newName: this.remark.remarkName,
        }).success((r) => {
          this.$Message.success('修改成功');
          this.editMode = false;
        }).failure((code: string, msg?: string) => {
          this.$Message.error(msg);
        }).error((e) => {
          this.$Message.error(e.toString());
        });
      } else {
        this.$Message.warning('标签名称不能为空');
      }
    },
    createDeleteTask() {
      commonClient.createTask({
        expectCount: this.remark!.count,
        input: {
          RemarkClear: {
            id: this.remark!.id,
          },
        },
        taskType: TaskType.RemarkClear,
      }).success((r) => {
        this.$emit('freeze', this.remark!.id);
      });
    },
  },
  beforeMount() {
    this.remark = this.outerRemark;
  },
});
